import jwtDecode from "jwt-decode";
import axiosInstance from "./axiosInstance";
import { backendbaseUrl } from "./baseUrl";
export const getAccessToken = () => localStorage.getItem("accessToken");
export const getRefreshToken = () => localStorage.getItem("refreshToken");

export const setTokens = (accessToken, refreshToken) => {
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
};

export const clearTokens = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
};

// Function to check if token is expired
export const isTokenValid = (token) => {
  if (!token) return false;

  try {
    const { exp } = jwtDecode(token);
    return Date.now() < exp * 1000; // Convert expiration time to milliseconds
  } catch (error) {
    return false;
  }
};

// Function to refresh access token
export const refreshAccessToken = async () => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) return null;

  try {
    const response = await axiosInstance.post(
      `${backendbaseUrl}/api/token/refresh/`,
      { refresh: refreshToken }
    );
    const newAccessToken = response.data.access;

    setTokens(newAccessToken, refreshToken);
    return newAccessToken;
  } catch (error) {
    console.error("Failed to refresh token", error);
    clearTokens();
    return null;
  }
};
